const PUBLIC_OFFER_PATH_SEGMENT = "(appointment|community|event|product|tip)";
const RESERVED_PUBLIC_ID_SEGMENTS = new Set(["app", "my"]);

export const isCanonicalPublicOfferRoutePath = (pathname: string): boolean => {
  const match = pathname.match(
    new RegExp(`^/([^/]+)/${PUBLIC_OFFER_PATH_SEGMENT}/[^/]+(?:/|$)`)
  );

  if (!match) {
    return false;
  }

  return !RESERVED_PUBLIC_ID_SEGMENTS.has(match[1]);
};

export const isLegacyPublicOfferRoutePath = (pathname: string): boolean =>
  new RegExp(
    `^/(app|my)/(?!expert(?:/|$))[^/]+/${PUBLIC_OFFER_PATH_SEGMENT}/[^/]+(?:/|$)`
  ).test(pathname);

export const isPublicOfferRoutePath = (pathname: string): boolean =>
  isCanonicalPublicOfferRoutePath(pathname) ||
  isLegacyPublicOfferRoutePath(pathname);

export const isExpertOfferManageRoutePath = (pathname: string): boolean =>
  /^\/my\/(community|event)\/[^/]+(?:\/|$)/.test(pathname);
